import React from 'react';

import EmptyContainer from 'pages/common/empty/components/EmptyContainer';

import NoResultsIllustration from './images/NoResultsIllustration.svg';

const NoRowsOverlay: React.FC = () => {
  return (
    <EmptyContainer
      imageSrc={NoResultsIllustration}
      Icon={null}
      buttonText={null}
      title={{ id: 'company.paymentsWorkspace.noPayments.title', defaultMessage: 'No payments' }}
      description1={{
        id: 'company.paymentsWorkspace.noPayments.description1',
        defaultMessage: "You don't have any payments under this status.",
      }}
      description2={{
        id: 'company.paymentsWorkspace.noPayments.description2',
        defaultMessage: 'Explore other tabs above to see more.',
      }}
    />
  );
};

export default NoRowsOverlay;
